import { render } from "./channel-inviting-inputs.vue?vue&type=template&id=357293d2&lang=pug"
import script from "./channel-inviting-inputs.vue?vue&type=script&lang=js"
export * from "./channel-inviting-inputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__